import './assets/main.css'
import 'element-plus/dist/index.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { ElMessage } from 'element-plus'

import App from './App.vue'
import router from './router'

const app = createApp(App)

// 全局错误处理
app.config.errorHandler = (err, instance, info) => {
  console.error('Vue Error:', err)
  console.error('Error Info:', info)
  console.error('Component:', instance)

  // 向用户显示友好的错误提示
  ElMessage.error({
    message: '应用发生错误，请刷新页面重试',
    duration: 5000,
  })
}

// 全局警告处理（仅开发环境）
if (import.meta.env.DEV) {
  app.config.warnHandler = (msg, instance, trace) => {
    console.warn('Vue Warning:', msg)
    console.warn('Trace:', trace)
  }
}

// 全局未捕获的 Promise 错误
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled Promise Rejection:', event.reason)
  ElMessage.error({
    message: '请求失败，请检查网络连接',
    duration: 3000,
  })
  event.preventDefault()
})

// 全局 JavaScript 错误
window.addEventListener('error', (event) => {
  console.error('Global Error:', event.error)
  // 静默处理资源加载错误
  if (event.target !== window) {
    console.warn('Resource loading error:', event.target)
    return
  }
})

app.use(createPinia())
app.use(router)

app.mount('#app')
